import { createAsyncThunk } from '@reduxjs/toolkit';
import type { IState } from '../store';
import { persistUserPreferences } from './persistUserPreferences';

export const clearWorkloadFilters = createAsyncThunk<void, void, { state: IState }>(
  'uiView/clearWorkloadFilters',
  (_, { dispatch }) => {
    dispatch(persistUserPreferences());
  }
);
